<template>
  <div class="exb">
    <div class="item" @click="go(1)"></div>
    <div class="item item1" @click="go(2)"></div>
    <div class="item item2" @click="go(3)"></div>
    <div class="item item3" @click="go(4)"></div>
    <div class="item item4" @click="go(5)"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    go(num) {
      if (num == 1) {
        window.location.href =
          "http://www.ycbwg.com/web/zhengguan.asp?bigclassid=102&smallclassid=259";
        return false;
      }
      if (num == 2) {
        window.location.href =
          "http://www.ycbwg.com/web/zhengguan.asp?bigclassid=102&smallclassid=260";
        return false;
      }
      if (num == 3) {
        window.location.href =
          "http://www.ycbwg.com/web/zhengguan.asp?bigclassid=102&smallclassid=261";
        return false;
      }
      if (num == 4) {
        window.location.href =
          "http://www.ycbwg.com/web/zhengguan.asp?bigclassid=102&smallclassid=263";
        return false;
      }
      if (num == 5) {
        window.location.href =
          "http://www.ycbwg.com/web/zhengguan.asp?bigclassid=102&smallclassid=264";
        return false;
      }
    }
  }
};
</script>
<style scoped>
.exb {
  padding: 30px 20px 0;
}
.item {
  width: 100%;
  height: 100px;
  margin-bottom: 20px;
  background: url(../../static/images/1.png) no-repeat;
  background-size: cover;
}
.item1 {
  background: url(../../static/images/2.png) no-repeat;
  background-size: cover;
}
.item2 {
  background: url(../../static/images/3.png) no-repeat;
  background-size: cover;
}
.item3 {
  background: url(../../static/images/4.png) no-repeat;
  background-size: cover;
}
.item4 {
  background: url(../../static/images/5.png) no-repeat;
  background-size: cover;
}
</style>




// WEBPACK FOOTER //
// src/components/exb.vue